import { SVGProps } from 'react'

export const ArrowCircleDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g filter='url(#filter0_b_18546_869)'>
      <rect width='24' height='24' rx='12' fill='white' />
      <rect
        x='0.2'
        y='0.2'
        width='23.6'
        height='23.6'
        rx='11.8'
        stroke='#A0ABBE'
        strokeWidth='0.4'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.0009 13.3475L7.46527 8.84966C7.12914 8.51675 6.58702 8.51675 6.25089 8.84966C6.09032 9.00828 6 9.22465 6 9.45033C6 9.676 6.09032 9.89237 6.25089 10.051L11.3928 15.1495C11.7286 15.4835 12.2714 15.4835 12.6072 15.1495L17.7491 10.0512C17.9097 9.89237 18 9.676 18 9.45033C18 9.22465 17.9097 9.00828 17.7491 8.84944C17.4129 8.51675 16.8708 8.51675 16.5347 8.84987L12.0009 13.3475Z'
        fill='#A0ABBE'
      />
    </g>
    <defs>
      <filter
        id='filter0_b_18546_869'
        x='-180'
        y='-180'
        width='384'
        height='384'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feGaussianBlur in='BackgroundImageFix' stdDeviation='90' />
        <feComposite
          in2='SourceAlpha'
          operator='in'
          result='effect1_backgroundBlur_18546_869'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_backgroundBlur_18546_869'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
